import { landingPageViewState } from "./LandingPageViewState";
import { mutatorAction } from "satcheljs";

export default mutatorAction("setCanCreateTeam", function setCanCreateTeam(
    canCreateTeam: boolean
) {
    landingPageViewState().canCreateTeam = canCreateTeam;
});
